import type { CityConfig } from "../city-template/types";

export const moabUTConfig: CityConfig = {
  city: "Moab",
  state: "Utah",
  stateAbbr: "UT",
  slug: "moab",
  route: "/cities/moab",
  title: "Emergency Passport Moab, UT | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Moab, UT — as fast as 24 hours. Serving Grand County and Southeast Utah. A+ BBB rated registered State Dept. courier serving Arches and Canyonlands National Park gateway communities. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Moab, UT",
  heroSubtitle: "Last-minute guided tour to Peru departing in 6 days? Adventure race in Patagonia and your passport is expired? International geology conference in Iceland and your documents are not ready? We help Moab residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20landscape%20view%20of%20Moab%20Utah%20with%20red%20rock%20formations%20Delicate%20Arch%20in%20distance%20sandstone%20cliffs%20Colorado%20River%20winding%20through%20canyon%20desert%20scenery%20dramatic%20golden%20hour%20sunset%20light%20professional%20outdoor%20photography%20adventure%20destination%20aesthetic&width=1800&height=700&seq=moab-ut-hero-2026&orientation=landscape",
  heroImageAlt: "Moab Utah red rock landscape with Delicate Arch and Colorado River at golden hour",
  geoPosition: "38.5733;-109.5498",
  geoPlacename: "Moab, Utah",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located in Aurora, CO — approximately 380 miles northeast of Moab via I-70",
  },
  nearbyCitiesZips: [
    { name: "Moab", zips: "84532" },
    { name: "Monticello", zips: "84535" },
    { name: "Blanding", zips: "84511" },
    { name: "Green River", zips: "84525" },
    { name: "Price", zips: "84501" },
    { name: "Castle Dale", zips: "84513" },
    { name: "La Sal", zips: "84530" },
    { name: "Spanish Valley", zips: "84532" },
    { name: "Thompson Springs", zips: "84540" },
    { name: "Cisco", zips: "84515" },
    { name: "Grand Junction", zips: "81501" },
    { name: "Fruita", zips: "81521" },
    { name: "Helper", zips: "84526" },
    { name: "Wellington", zips: "84542" },
    { name: "Dove Creek", zips: "81324" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southeast Utah departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Red Rock Country", desc: "Serving Moab, Monticello, Blanding, and all of Grand County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. George, UT", route: "/cities/st-george" },
    { name: "Fast passport renewal in Salt Lake City, UT", route: "/cities/salt-lake-city" },
    { name: "Emergency passport help in Provo, UT", route: "/cities/provo" },
    { name: "Urgent passport services in Denver, CO", route: "/cities/denver" },
    { name: "Same-day passport help in Grand Junction, CO", route: "/cities/grand-junction" },
    { name: "Passport courier services in Ogden, UT", route: "/cities/ogden" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Moab remotely via secure courier. We do not have a walk-in office in Moab — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Grand County and Southeast Utah.",
  fpcOfficeAddress: "299 S Main St, Salt Lake City, Utah 84111",
  fpcOfficeDistance: "Serving all of Grand County and the Southeast Utah canyon country including San Juan, Emery, and Carbon counties",
  serviceAreaIntro: "From the adventure hub of downtown Moab and the iconic red rock formations of Arches National Park to the sandstone expanses of Canyonlands, from the uranium heritage of Monticello to the Ancestral Puebloan sites near Blanding, from the Green River melon farms to the coal country towns of Price and Helper — Fast Passport Center serves the entire Southeast Utah and canyon country region. We regularly help travelers from Grand County, San Juan County, and surrounding areas get their passports fast without the 380-mile drive to Denver.",
  nearbyCitiesIntro: "We serve all Moab neighborhoods and the surrounding Southeast Utah area including Monticello, Blanding, Green River, Price, Castle Dale, La Sal, and Spanish Valley. If you are anywhere in Grand County, San Juan County, or Emery County, we have you covered.",
  howItWorksIntro: "Most Moab travelers complete everything online and ship documents overnight. No need to drive to Denver or Grand Junction — we handle the courier submission for you.",
  mistakesIntro: "Moab travelers often face a 5.5-hour drive to the nearest regional passport agency in Denver. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Moab and Grand County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Moab? Here are the most common ones we hear from Southeast Utah travelers.",
  statePageRoute: "/states/utah",
  statePageName: "Utah",
  dmvWebsite: "https://dmv.utah.gov",
  dmvLabel: "Utah DMV — Division of Motor Vehicles",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Moab travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Dave R.",
      location: "Moab, UT",
      rating: 5,
      text: "Guided Patagonia expedition in 5 days and my passport was expired. Fast Passport Center got it in 28 hours. Red rocks to Patagonia — I made every single day of the trip!",
      service: "Passport Renewal",
    },
    {
      name: "Sarah J.",
      location: "Blanding, UT",
      rating: 5,
      text: "My son's school trip to Costa Rica was in 4 days and we discovered his passport had expired. Fast Passport Center expedited it in 32 hours. Southeast Utah to the rainforest just like that.",
      service: "Child Passport",
    },
    {
      name: "Mike G.",
      location: "Green River, UT",
      rating: 5,
      text: "Medical research conference in Geneva with 6 days notice. Fast Passport Center handled my emergency passport in 26 hours. My dedicated agent was a lifesaver. Incredible.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "moab-ut-1",
      name: "Moab Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 E 100 N",
      city: "Moab",
      state: "UT",
      zip: "84532",
      phone: "(435) 259-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Moab",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Moab facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "moab-ut-2",
      name: "Grand County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "125 E Center St",
      city: "Moab",
      state: "UT",
      zip: "84532",
      phone: "(435) 259-1321",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Moab Courthouse",
      website: "https://www.grandcountyutah.net/150/Clerk-Auditor",
      websiteLabel: "Grand County Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "moab-ut-3",
      name: "Monticello Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "55 S Main St",
      city: "Monticello",
      state: "UT",
      zip: "84535",
      phone: "(435) 587-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles south of Moab",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves San Juan County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "moab-ut-4",
      name: "Price Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "95 S Carbon Ave",
      city: "Price",
      state: "UT",
      zip: "84501",
      phone: "(435) 637-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "110 miles northwest of Moab",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Carbon and Emery counties. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Denver", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Moab photo shops sometimes use adventure or outdoor backgrounds. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Grand County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Moab applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Grand County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Moab travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Moab." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Moab address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Moab before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Moab for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5-hour drive to Denver." },
    { q: "How fast can I renew my passport in Moab?", a: "Fast Passport Center offers fast passport renewal in Moab in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Moab?", a: "The nearest regional passport agency to Moab is the Denver Passport Agency, approximately 380 miles northeast via I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Moab without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Moab?", a: "Same-day passport appointments are only available at the Denver Regional Passport Agency — approximately 5.5 hours from Moab — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Grand County and Southeast Utah residents." },
    { q: "Do you serve the entire Southeast Utah region?", a: "Absolutely. Fast Passport Center serves the entire Southeast Utah and canyon country region including Moab, Monticello, Blanding, Green River, Price, and surrounding areas. Our courier service works seamlessly from any address in Grand County, San Juan County, or Emery County." },
    { q: "Can I expedite a child passport in Moab?", a: "Yes. Fast Passport Center expedites child passports in Moab for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Southeast Utah families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Moab with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Denver Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "City Market — Moab", address: "425 S Main St, Moab, UT 84532", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Grand Junction", address: "2401 North Ave, Grand Junction, CO 81501", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Grand Junction", address: "2881 North Ave, Grand Junction, CO 81501", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walker Drug — Moab", address: "290 S Main St, Moab, UT 84532", hours: "Mon–Sat: 9AM–7PM" },
  ],
  dmvLocations: [
    {
      name: "Utah DMV — Moab",
      address: "125 E Center St, Moab, UT 84532",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended. Located at Grand County Courthouse.",
      featured: true,
    },
    {
      name: "Utah DMV — Price",
      address: "120 E Main St, Price, UT 84501",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Serves Carbon and Emery counties. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CNY",
      name: "Canyonlands Regional Airport",
      distance: "18 miles north of Moab",
      address: "110 W Aviation Way, Moab, UT 84532",
      note: "Regional airport with daily flights to Denver via United Express. About 25 minutes from downtown Moab.",
      flightUrl: "https://www.grandcountyutah.net/306/Airport",
      flightLabel: "CNY Airport",
      featured: true,
    },
    {
      code: "GJT",
      name: "Grand Junction Regional Airport",
      distance: "115 miles northeast of Moab",
      address: "2828 Walker Field Dr, Grand Junction, CO 81506",
      note: "Regional airport with direct flights to major hubs. About 2 hours from Moab via I-70.",
      flightUrl: "https://www.gjairport.com/",
      flightLabel: "GJT Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Utah birth and death certificates from the Utah Department of Health Vital Records in Salt Lake City — online, by mail, or in person.", url: "https://vitalrecords.utah.gov/" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Grand County Clerk in Moab. Located at the Grand County Courthouse on Center Street.", url: "https://www.grandcountyutah.net/150/Clerk-Auditor" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Grand County District Court. Required for name change passport corrections.", url: "https://www.utcourts.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Utah, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};